    const checkoutRoutes = [
    {
        path: "/checkout",
        name: "checkout",
        component: () => import("@/views/checkout/Checkout")
    },
    {
        path: "/checkout/:id?",
        name: "checkoutPerson",
        component: () => import("@/views/checkout/CheckoutPerson"),
        props: route => {
            const id = Number.parseInt(route.params.id, 10);
            if (Number.isNaN(id)) {
                return 0;
            }
            return {id};
        }
    },
    {
        path: "/checkout/:id/:scheduleID",
        name: "checkoutSchedule",
        component: () => import("@/views/checkout/CheckoutSchedule"),
        props: route => {
            let id = Number.parseInt(route.params.id, 10);
            if (Number.isNaN(id)) {
                id = 0;
            }

            let scheduleID = Number.parseInt(route.params.scheduleID, 10);
            if (Number.isNaN(scheduleID)) {
                scheduleID = 0;
            }
            return {id: id, scheduleID: scheduleID};
        }

    }
]
export default checkoutRoutes